/** Fallback when user clicks Browse site */
export const DEFAULT_HOME_SPLIT_PAGE = 'products';

let activeSplitId: string | null = null;
const listeners = new Set<(id: string | null) => void>();

export function getAvatarSplitId(): string | null {
  return activeSplitId;
}

export function subscribeAvatarSplit(listener: (id: string | null) => void): () => void {
  listeners.add(listener);
  listener(activeSplitId);
  return () => listeners.delete(listener);
}

export function setAvatarSplitContent(sectionId: string | null): void {
  activeSplitId = sectionId;
  listeners.forEach((fn) => fn(sectionId));
  if (sectionId) {
    window.dispatchEvent(
      new CustomEvent('selflabs:open-split', { detail: { id: sectionId } })
    );
  } else {
    window.dispatchEvent(new CustomEvent('selflabs:open-split-clear'));
  }
}

/** Bump iframe reload when the same page is requested again. */
export function bumpAvatarSplitReload(): void {
  window.dispatchEvent(new CustomEvent('selflabs:open-split-reload'));
}

/** @deprecated use setAvatarSplitContent */
export function setAvatarSplitId(id: string | null): void {
  setAvatarSplitContent(id);
}

export function resetAvatarSplitContent(): void {
  setAvatarSplitContent(null);
}
